<template>
    <div class="detail_body posi_rela">
        <div class="loading_bd flex_c" v-if="detailLoading">
            <div class="loading_con flex_c">
                <el-icon class="loading_size is-loading">
                    <Loading/>
                </el-icon>
                <div class="loading_text">数据加载中</div>
            </div>
        </div>
        <div class="patient_info_body">
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font font1_2rem flex_c_left">
                        <span class="no_font">NO.</span><span class="no_num_font">{{ medicalOrder.serialNo }}</span>
                    </div>
                    <div class="detail_font status_font flex_c_right">
                            <span :class="medicalOrder.status === '1' || medicalOrder.status === '6' ? 'text-blue':
                            medicalOrder.status === '2' || medicalOrder.status === '5' ? 'text-orange':
                            medicalOrder.status === '3' || medicalOrder.status === '4' ? 'text-red':'text-grey1'">{{
                                    getOrderStatus(medicalOrder.status)
                                }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font flex_c_left">
                        <span class="mrr20"><span class="font_gray">姓名：</span>{{ patientInfo.name }}</span>
                        <span class="mrr20"><span
                            class="font_gray">性别：</span>{{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }}</span>
                        <span class="mrr20"><span
                            class="font_gray">年龄：</span>{{ patientInfo.age === null ? '--' : patientInfo.age }}岁</span>
                        <span class="mrr20"><span
                            class="font_gray">联系电话：</span>{{ patientInfo.phoneNumber === null ? '无' : patientInfo.phoneNumber }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">身份证号码：</span>{{patientInfo.identity===null?"--":patientInfo.identity.substr(0,6) + '********' + patientInfo.identity.substr(14, 20)}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">联系地址：</span>{{ patientInfo.province === null ? '无' : patientInfo.province }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font flex_c_left">
                        <span
                            class="font_gray">临床诊断：</span>{{ medicalOrder.clinicalDiagnosis === null ? '无' : medicalOrder.clinicalDiagnosis }}
                    </div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">RP：
                        <span
                            class="font_gold">{{
                                medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : medicalOrder.billingType === '3' ? '水丸' : '颗粒'
                            }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="med_list_con flex_left_warp">
                        <div class="med_list_li flex_c_between" v-for="(item, index) in medicalOrder.orderMedicineList"
                             :key="index">
                            <!-- 超量签章水印（左上角） -->
                            <div class="usage_sign_badge" v-if="item.isOverLimit">{{ item.usageSignName }}</div>
                            <!-- 超量提示（底部浮动） -->
                            <div class="usage_sign_remark" v-if="item.isOverLimit">{{ item.usageSignRemark }}</div>
                            <span class="font_gold"
                                  v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && (medicalOrder.billingType === '0' || medicalOrder.billingType === 0) && newRuleOpen">[{{
                                    item.standard
                                }}]</span>
                            <span class="med_li_name">{{ item.meName }}</span>
                            <span class="font_gold"
                                  v-if="item.drugProperty && item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{
                                    item.drugProperty
                                }})</span>
                            <span class="font_gray"
                                  v-if="item.decoctionId && item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && (medicalOrder.billingType !== '0' && medicalOrder.billingType !== 0) && item.decoctionName !== '无'">({{
                                    item.decoctionName
                                }})</span>
                            <span class="font_gray mrl10">{{ item.newGCount }}g</span>
                        </div>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col"
                     v-if="medicalOrder.billingType === '2' && medicalOrder.orderMedicineFuList.length > 0">
                    <div class="detail_font flex_c_left">辅料：</div>
                    <div class="font_black">{{ showOrderMedicineFuList }}</div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font flex_c_left">每剂 {{ medicalOrder.orderMedicineList.length }} 味药材，共
                        {{ medicalOrder.viceNum }} 剂
                    </div>
                    <div class="detail_font flex_c_left">
                        <span class="font_gray">药方总重：</span>
                        <span
                            class="detail_font_red">{{ getOrderWeightByNewGCount(medicalOrder.orderMedicineList) }}g</span>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col">
                    <div class="detail_font flex_c_top">
                        <div class="f_left font_gray">用法：</div>
                        <div class="f_right">{{ medicalOrder.instructions }}</div>
                    </div>
                    <div class="detail_font flex_c_left"><span
                        class="font_gray">*每次服用袋数请参照随药寄送的贴纸说明</span></div>
                </div>
            </div>

            <!-- 费用明细-->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">费用明细：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap">
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'">
                        <span class="font_gray">药材费用：</span>
                        <span class="detail_font_red">{{ medicalOrder.medicalCountPrice }}</span><span
                        class="font_gold">元</span>
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.billingType !== '0'"><span
                        class="font_gray">加工费用：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.processingCosts === null || medicalOrder.processingCosts === undefined ? '0.00' : medicalOrder.processingCosts
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span
                        class="font_gray">医生诊金：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.docPrice === null ? "0" : medicalOrder.docPrice
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span
                        class="font_gray">诊后病程管理费用：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.adjustmentPrice === null ? "0" : medicalOrder.adjustmentPrice
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
<!--                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span-->
<!--                        class="font_gray">优惠金额：</span>-->
<!--                        <span-->
<!--                            class="detail_font_red">{{-->
<!--                                medicalOrder.discountPrice === null ? "0" : medicalOrder.discountPrice-->
<!--                            }}</span><span-->
<!--                            class="font_gold">元</span>-->
<!--                    </div>-->
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span
                        class="font_gold">总金额：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.orderPrice === null ? "0" : medicalOrder.orderPrice
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
                </div>
            </div>

            <!-- 药方配送 -->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">配送信息：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap" v-if="medicalOrder.deliverWay === '0'">
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">配送方式：</span>
                        <span>物流配送</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">物流公司：</span>
                        <span>{{medicalOrder.trackingCom === null ? '无':medicalOrder.trackingCom}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">收货信息：</span>
                        <span>{{medicalOrder.receivePersonName}}&nbsp;&nbsp;&nbsp;&nbsp;{{medicalOrder.receivePhone}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">物流单号：</span>
                        <span>{{medicalOrder.trackingNo === null ? '无':medicalOrder.trackingNo}}</span>
                    </div>
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">配送地址：</span>
                        <span>{{medicalOrder.receiveProvince}}{{medicalOrder.receiveCity}}{{medicalOrder.receiveCountry}}{{medicalOrder.receiveAddress}}</span>
                    </div>
                </div>

                <div class="detail_info_line flex_c_top flex_c_wrap" v-if="medicalOrder.deliverWay === '1'">
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">配送方式：</span>
                        <span>门诊自取</span>
                    </div>
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">自取门诊：</span>
                        <span>二七知夏中医门诊部</span>
                    </div>
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">门诊地址：</span>
                        <span>河南省郑州市二七区五里堡街道建设东路49号中投汇金城北门旁（导航搜索：知夏中医）</span>
                    </div>
                </div>
            </div>

            <!-- 其他信息 -->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">其他信息：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap">
                    <div class="detail_font50 flex_c_left"><span class="font_gray">开方剂型：</span>
                        {{
                            medicalOrder.billingType === null || medicalOrder.billingType === '0' ? '颗粒' : medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : '水丸'
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">开方时间：</span>{{
                            medicalOrder.createTime === null ? "---" : medicalOrder.createTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">接单时间：</span>{{
                            medicalOrder.receiveTime === null ? "---" : medicalOrder.receiveTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '5'"><span
                        class="font_gray">驳回时间：</span>{{
                            medicalOrder.rejectTime === null ? "---" : medicalOrder.rejectTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">支付时间：</span>{{
                            medicalOrder.payTime === null ? "---" : medicalOrder.payTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">发货时间：</span>{{
                            medicalOrder.deliverTime === null ? "---" : medicalOrder.deliverTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '7'">
                            <span
                                class="font_gray">收货时间：</span>{{
                            medicalOrder.completeTime === null ? "---" : medicalOrder.completeTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '8'">
                            <span
                                class="font_gray">取消时间：</span>{{
                            medicalOrder.cancelTime === null ? "---" : medicalOrder.cancelTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"><span
                        class="font_gray">开方备注：</span>{{
                            medicalOrder.remark === '' || medicalOrder.remark === null ? '无' : medicalOrder.remark
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div class="patient_order_detail">
            <div class="detail_info_line flex_c_between">
                <div class="width100 name_font">总费用：<span
                    class="detail_font_red">{{ medicalOrder.orderPrice }}</span><span class="font_gold">元</span>
                </div>
                <div class="flex_c_right">
                    <el-button type="success" v-if="medicalOrder.status === '3'" @click="openPayScreen()">收费</el-button>
                    <el-button type="primary" @click="exportOrder">处方笺</el-button>
                    <el-button type="warning" @click="oneMoreOrder">再来一单</el-button>
                    <el-button type="warning" v-if="medicalOrder.status === '1' || medicalOrder.status === '3'"
                               @click="userEditOrder">修改
                    </el-button>
                    <el-button type="danger" v-if="medicalOrder.status === '1' || medicalOrder.status === '3'"
                               @click="userCancelOrder">作废
                    </el-button>
                </div>
            </div>
        </div>
    </div>

    <!-- 处方笺预览-->
    <el-dialog v-model="prescriptionPaperDialogDialogVisible" width="600px" center>
        <div class="prescriptionPaperDialog" id="printArea">
            <div class="paper_title_con">
                <div class="paper_title">知夏中医门诊部专用处方笺</div>
            </div>
            <div class="paper_line flex_c_col">
                <div class="width100 flex_c_between">
                    <span class="paper_line_left flex_c_left">姓名：{{patientInfo.name}}</span>
                    <span class="paper_line_left flex_c">性别：{{patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知'}}</span>
                    <span class="paper_line_left flex_c_right">年龄：{{patientInfo.age === null ? '--' : patientInfo.age}}岁</span>
                </div>
                <div class="width100 flex_c_between">
                    <div class="paper_line_left flex_c_left">
                        <span>处方号：{{medicalOrder.serialNo}}</span>
                    </div>
                    <div class="paper_line_left flex_c_right">
                        <span>日期：{{medicalOrder.createTime}}</span>
                    </div>
                </div>
            </div>
            <div class="paper_line flex_left_warp">
                <span>临床诊断：{{medicalOrder.clinicalDiagnosis === null ? '无' : medicalOrder.clinicalDiagnosis}}</span>
            </div>
            <div class="paper_line flex_t_col">
                <div class="detail_info_line flex_c_between">
                    <div class="width100" style="font-size: 18px;font-weight: bold">RP：
                        <span class="font_gold">{{ medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : medicalOrder.billingType === '3' ? '水丸' : '颗粒' }}</span>
                    </div>
                </div>
                <div class="detail_info_line detail_con">
                    <div class="med_list_con flex_left_warp">
                        <div class="med_list_li flex_c_between" v-for="(item, index) in medicalOrder.orderMedicineList" :key="index">
                            <span class="med_li_name12">{{ item.meName }}</span>
                            <span class="font_gold"
                                  v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{ item.drugProperty }})</span>
                            <span class="font_gray"
                                  v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && item.decoctionName !== '无'">({{ item.decoctionName }})</span>
                            <span class="mrl10">{{ item.newGCount }}<span class="mrl5">g</span></span>
                        </div>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col"
                     v-if="medicalOrder.billingType === '2' && medicalOrder.orderMedicineFuList.length > 0">
                    <div class="detail_font flex_c_left">辅料：</div>
                    <div class="font_black">{{ showOrderMedicineFuList }}</div>
                </div>
                <div class="detail_info_line flex_c_col">
                    <div class="mrt10 font_weight">{{ medicalOrder.instructions }}</div>
                    <div class="mrt10 font_weight">- - - - - 处方内容完毕 - - - - -</div>
                    <div class="mrt10">每剂 {{ medicalOrder.orderMedicineList.length }} 味药材，共{{ medicalOrder.viceNum }} 剂</div>
                </div>
            </div>
            <div class="paper_line paper_bottom_border flex_c_between">
                <div class="paper_ercode">
                    <el-image class="qrCode"
                              :src="tencentCosUrl+medicalOrder.payQrcode"
                              :zoom-rate="1.2"
                              :max-scale="7"
                              :min-scale="0.2" :hide-on-click-modal="true"
                              :preview-src-list="payCodeList"
                              fit="fill"
                    />
                    <div class="qrCode_info">扫码线上支付</div>
                </div>
                <!--            <div class="paper_ercode_right">-->
                <!--                <el-image class="qrCode" :src="tencentCosUrl+doctorInfo.qrCode" fit="fill"></el-image>-->
                <!--                <div class="qrCode_info">扫码关联医师</div>-->
                <!--            </div>-->
                <div class="paper_line_two flex_t_col">
                    <div class="paper_line_ifo flex_c_left"><span class="font_black">*每次服用袋数请参照随药寄送的贴纸说明</span></div>
<!--                    <div class="paper_line_ifo flex_c_left"><span class="font_black">药方总重：</span><span class="detail_font_gold">{{getOrderWeightByNewGCount(medicalOrder.orderMedicineList)}}</span>g</div>-->
                    <div class="paper_line_ifo flex_c_left"><span class="font_black">药方总费用：</span><span class="detail_font_red">{{ medicalOrder.orderPrice }}</span>元</div>
                </div>
            </div>
            <div class="paper_line flex_bot_between">
                <div class="paper_line_left_left flex_c_left">
                    <div class="paper_left">核对/发药：</div>
                    <div class="paper_right">
                        <span>{{medicalOrder.billingType === '0'?'知夏中医颗粒药房':'知夏中医饮片药房'}}</span>
                    </div>
                </div>
                <div class="paper_line_left flex_right_bottom">
                    <div class="paper_left">核发医师：</div>
                    <div class="paper_right">
                        <el-image style="height: 42px" :src="tencentCosUrl+doctorInfo.signPic" fit="cover"></el-image>
                    </div>
                </div>
            </div>
            <div class="paper_line_bot flex_c_between">
                <div class="paper_line_left flex_left_bottom">
                </div>
                <div class="paper_line_left flex_c_right">
                    <span>打印日期：{{printDate}}</span>
                </div>
            </div>
        </div>

        <template #footer >
            <div class="dialog-footer no-print">
                <el-button @click="cancelOrderPrint()">取消</el-button>
                <el-button type="primary" v-print="printInfoObj">打印</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 订单收费 -->
    <el-dialog
        v-model="orderPayDialogVisible"
        :before-close="cancalPay"
        title="订单收费"
        width="32%"
        align-center
    >
        <div class="pay_content flex_c_col">
            <div class="pay_main_body flex_t_col">
                <!--等待扫码-->
                <div class="pay_screen_con flex_c_col" v-if="isWaitPayLoading && !payLoading && !isPayed">
                    <el-icon class="pay_screen_icon">
                        <Connection />
                    </el-icon>
                    <div class="pay_screen_text">正在等待扫码中，请稍候...</div>
                </div>
                <!--加载圈-->
                <div class="pay_loading_con flex_c_col" v-if="isWaitPayLoading && payLoading && !isPayed">
                    <el-icon class="pay_loading_icon is-loading">
                        <loading />
                    </el-icon>
                    <div class="pay_loading_text">正在等待订单支付，请稍候...</div>
                </div>
                <!-- 订单信息-->
                <div class="pay_order_main" v-if="isWaitPayLoading && !isPayed">
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">患者信息：</div>
                        <div class="pay_info_item_right">{{ patientInfo.name }} {{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }} {{ patientInfo.age === null ? '--' : patientInfo.age }}岁</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">身份证号：</div>
                        <div class="pay_info_item_right">{{patientInfo.identity===null?"--":patientInfo.identity.substr(0,6) + '********' + patientInfo.identity.substr(14, 20)}}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">药方单号：</div>
                        <div class="pay_info_item_right">{{ medicalOrder.serialNo }}</div>
                    </div>
                    <div class="pay_info_title">支付信息</div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">医生诊金：</div>
                        <div class="pay_info_item_right">￥{{medicalOrder.docPrice === null ? "0.00" : medicalOrder.docPrice}}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">加工费用：</div>
                        <div class="pay_info_item_right">￥{{medicalOrder.processingCosts === null || medicalOrder.processingCosts === undefined ? '0.00' : medicalOrder.processingCosts}}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">订单实付：</div>
                        <div class="pay_info_item_right font_weight font_orange font_28">￥{{ medicalOrder.orderPrice }}</div>
                    </div>
                    <div class="pay_warning_info flex_t_col">
                        <div class="pay_warning_li">*特殊说明：</div>
                        <div class="pay_warning_li">①请仔细核对患者和订单信息，避免错误收费。</div>
                        <div class="pay_warning_li">②请患者打开移动付款码放置扫码盒子上或使用扫码枪扫患者的付款二维码，完成支付。</div>
                    </div>
                </div>
                <!-- 订单结果-->
                <div class="pay_order_main" v-if="!isWaitPayLoading && isPayed">
                    <div class="pay_order_success flex_c_col">
                        <el-icon class="pay_order_success_icon font_green" v-if="payState === 'success'">
                            <SuccessFilled />
                        </el-icon>
                        <el-icon class="pay_order_success_icon font_orange" v-if="payState === 'pending'">
                            <WarningFilled />
                        </el-icon>
                        <el-icon class="pay_order_success_icon font_red" v-if="payState === 'failed'">
                            <CircleCloseFilled />
                        </el-icon>
                        <div class="pay_order_success_text flex_c font_16"><span class="font_gold mrlr10 font_18">{{ patientInfo.name }}</span>的药方订单{{ payResultText }}</div>
                        <div class="pay_order_error_text flex_c font_14" v-if="payState !== 'success' && payErrorMsg"
                             :style="{color: payState === 'pending' ? '#e6a23c' : '#f56c6c', margin: '8px 0'}">{{ payErrorMsg }}</div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">药方单号：</div>
                            <div class="pay_info_item_right font_weight">{{ medicalOrder.serialNo }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">支付单号：</div>
                            <div class="pay_info_item_right font_weight">{{ medicalOrder.serialNo }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between" v-if="successPayed">
                            <div class="pay_info_item_left">支付时间：</div>
                            <div class="pay_info_item_right font_weight">{{ medicalOrder.payTime }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">医生诊金：</div>
                            <div class="pay_info_item_right">￥{{medicalOrder.docPrice === null ? "0.00" : medicalOrder.docPrice}}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">加工费用：</div>
                            <div class="pay_info_item_right">￥{{medicalOrder.processingCosts === null || medicalOrder.processingCosts === undefined ? '0.00' : medicalOrder.processingCosts}}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">订单实付：</div>
                            <div class="pay_info_item_right font_weight font_orange font_28">￥{{ medicalOrder.orderPrice }}</div>
                        </div>
                        <div class="pay_warning_info flex_t_col">
                            <div class="pay_warning_li">*特殊说明：</div>
                            <div class="pay_warning_li">①若订单支付失败，请重新扫患者的付款二维码进行扫码支付。</div>
                            <div class="pay_warning_li">②支付完成后，请告知患者可打开“知夏中医健康平台”小程序，查询订单支付结果。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="warning" :loading="querying" v-if="isPayed && payState === 'pending'" @click="requeryPayResult()">重新查询</el-button>
                <el-button type="danger" v-if="isPayed && payState === 'failed'" @click="cancalOrRefreshPay()">刷新重试</el-button>
<!--                <el-button type="success" v-if="isPayed && successPayed" onclick="printPayed()">打印小票</el-button>-->
<!--                <el-button type="primary" v-if="!isPayed" @click="printPayInfo()">打印单据</el-button>-->
                <el-button type="info" @click="cancalPay()">取消</el-button>
            </div>
        </template>
    </el-dialog>

</template>

<script>
import orderdetail from "@/assets/scripts/components/orderdetail";

export default orderdetail;
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";
</style>
